import { render, staticRenderFns } from "./BelowHelpBlock.vue?vue&type=template&id=5bda60c5"
import script from "./BelowHelpBlock.vue?vue&type=script&lang=js"
export * from "./BelowHelpBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports